{{#if $isMobile.any}}
<button class="nav-button nav-button-back nav-button-{{ backButtonDisplay ? 'visible' : 'hidden' }} nav-button-index-{{ $index_active ? 'active' : 'inactive' }}" on:click="back()"></button>

<button class="nav-button nav-button-forward nav-button-{{ forwardButtonDisplay ? 'visible' : 'hidden' }} nav-button-index-{{ $index_active ? 'active' : 'inactive' }}" on:click="forward()"></button>
{{/if}}

<button class="chapter-btn chapter-btn-index-{{ $index_active ? 'active' : 'inactive' }}" on:click="index()">
    <div class="chapter-icon chapter-icon--{{ chapter }}">
        <div class="chapter-icon__num">{{ chapter }}</div>
        <div class="chapter-icon__bg">
            <span class="chapter-icon__slice"></span>
            <span class="chapter-icon__slice"></span>
            <span class="chapter-icon__slice"></span>
        </div>
    </div>
    <div class="chapter-btn__text">{{ $current_chapter == 'intro' ? 'introduction' : $current_chapter }}</div>
</button>

<div class="chapter-progress chapter-progress-index-{{ $index_active ? 'active' : 'inactive' }}">
    <svg ref:svg style="height: {{ height }}px;">
    {{#each ticks as tick}}
        {{#if tick === $current_slide}}
        <line class="current" x1="0" x2="{{ width }}" y1="{{ tick * pad }}" y2="{{ tick * pad }}"></line>
        {{else}}
        <line x1="{{ width / 2 }}" x2="{{ width }}" y1="{{ tick * pad }}" y2="{{ tick * pad }}"></line>
        {{/if}}
    {{/each}}
    </svg>
</div>

<script>
import { range } from 'd3-array'
import { scaleBand } from 'd3-scale'

export default {

    data() {
        return {
            total: 0,
            width: 30,
        }
    },

    computed: {
        pad: ($isMobile) => $isMobile.any ? 6 : 10,
        chapter: ($current_chapter, $chapters) => $chapters.indexOf($current_chapter),
        ticks: total => range(total),
        height: (total, pad) => total * pad,
        //y: (ticks, height) => scaleBand().domain(ticks).range([0, height])
        backButtonDisplay: ($isMobile, $current_slide, $current_chapter) => {
            if ( !$isMobile.any ) return false;
            if ( $current_chapter == 'intro' && $current_slide == 0 ) return false;
            return true;
        },
        forwardButtonDisplay: ($isMobile, $current_slide, $slides, $current_chapter) => {
            if ( !$isMobile.any ) return false;
            if ( $current_chapter == 'wilmer' && ( ( $slides.length - 1 ) == $current_slide ) ) return false;
            return true;
        },
    },

    oncreate() {

        //this.resize();
    },

    methods: {
        resize() {
            const { width } = this.refs.svg.getBoundingClientRect();
            this.set({ width });
        },
        index() {
            if ( store.get('index_active') ) return;
            store.set({ index_active: true });   
        },
        back() {
            if ( !store.get('isMobile').any || store.get('index_active') ) return;
            if ( store.get('current_chapter') == 'intro' && store.get('current_slide') == 0 ) return false;
            if ( store.get('current_slide') == 0 ) {
                store.set({ index_active: true });
            } else {
                this.store.deck.prev();
            }
        },
        forward() {
            if ( !store.get('isMobile').any || store.get('index_active') ) return;
            if ( store.get('current_chapter') == 'wilmer' && ( ( store.get('slides').length - 1 ) == store.get('current_slide') ) ) return false;
            this.store.deck.next();
        }
    }
}
</script>